export const environment = {
  production: true,
  version: '2026.3',
  configFile: 'config.json',
};
